import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { $getRoot, $getSelection, createEditor } from 'lexical';
import { EssayHelper } from "../helpers/essay.helper";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createParagraphNode, $createTextNode } from 'lexical';
import { useNavigate } from 'react-router-dom';
import '../css/property-list.css';
import {
  Dialog, DialogTitle, FormLabel, FormControlLabel, IconButton, Paper, Button, Divider,
  Radio, RadioGroup, Select, Tooltip, Typography, MenuItem, FormControl, InputLabel, TextField, Grid
} from '@mui/material';
import Box from '@mui/material/Box';
import { AppHelper } from '../AppHelper';
import LoadingButton from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

export default function PageQuestion({
  onClose, open, model
}) {
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);  
  const [isSa, setIsSa] = useState(false);  
  const [isTea, setIsTea] = useState(false);  
  const [manageAccess, setManageAccess] = useState([]);
  const [oUser, setOUser] = React.useState(null);  
  const [msgBox, setMsgBox] = React.useState({
    open: false, vertical: 'top', horizontal: 'center', msg: ''
  });
  const [questionData, setQuestionData] = useState({
    text: '',
    files: [],
    grade: '',
    title: '',
    topic: '',
    transcribe: '', 
    uploadType: 0,
    saQuestion: 0,
  });

  const [gradeList, setGradeList] = useState([]);
  const [txtNameOK, setTxtNameOK] = useState(true);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [grade, setGrade] = useState('P5');
  const [ownership, setOwnership] = useState(0);
  const [saQuestion, setSaQuestion] = useState(0);
  const [title, setTitle] = useState('');
  const [topic, setTopic] = useState('');
  const [authOK, setAuthOK] = React.useState(false);
  const [question, setQuestion] = useState('');
  const [questionType, setQuestionType] = useState('-');
  const [questionTypeOK, setQuestionTypeOK] = useState(true);
  const [questionDataType, setQuestionDataType] = useState('text');
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [imagePreview, setImagePreview] = React.useState({ open: false, src: '', alt: '' });
  
  const fetchIAM = async(oUser)=>{
      var _res = await AppHelper.apiPost('api/account/iam', {token: oUser.token});
      if(!_res || !_res.status || !_res.data){
        return;
      }
      // Check if is teacher/tutor account, for the MANAGE access right  affecting the grade dropdown
      if (_res.data.account.accountType === "TEA") {
        setIsTea(true);
      }
      if(_res.data.isSa){
        setIsSa(true);
      }
    }
	
  const fetchImages = async (questionId) => {
    
    var _res = await AppHelper.apiPost('api/question/detail', { token: oUser.token, questionId: questionId });
    if (!_res || !_res.status) {
      setImageUrls([]);
    }
    else {
      setImageUrls(_res.question.imagesBase64);
    }
  };

  function htmlToLexicalNodes(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const root = $getRoot();

    function parseNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;

        if (element.nodeName === 'P') {
          const paragraphNode = $createParagraphNode();
          root.append(paragraphNode);
          Array.from(element.childNodes).forEach(child => parseNode(child));
        } else if (element.nodeName === 'STRONG') {
          // Handle <strong> element
          const parent = root.getLastChild();
          if (parent) {
            Array.from(element.childNodes).forEach(child => {
              if (child.nodeType === Node.TEXT_NODE) {
                const textNode = $createTextNode(child.textContent || '');
                textNode.toggleFormat('bold'); // Mark as bold in Lexical

                // Apply custom class
                textNode.setStyle('class', 'editor-text-bold');
                parent.append(textNode);
              }
            });
          }
        } else if (element.nodeName === 'SPAN') {
          const textNode = $createTextNode(element.textContent || '');
          const parent = root.getLastChild();
          if (parent) {
            parent.append(textNode);
          }
        }
      } else if (node.nodeType === Node.TEXT_NODE) {
        const textNode = $createTextNode(node.textContent || '');
        const parent = root.getLastChild();
        if (parent) {
          parent.append(textNode);
        }
      }
    }

    // Start parsing from the root
    Array.from(doc.body.childNodes).forEach(parseNode);
  }

  const fetchGrades = async (oUser) => {
    var filteredGrade = [];
    var grade = await EssayHelper.essayGradeGet(oUser.token);
    if (isTea) {
      await fetchAccessRight(oUser);
      grade.forEach((g => {
        if (manageAccess.includes(g.id)) {
          filteredGrade.push(g);
        }
      }))
      setGradeList(filteredGrade);
      return;
    }
    setGradeList(grade);
  };

  const gradeSelect = async (arg) => {
    setGrade(arg.target.value);
  };
  const ownershipSelect = async (arg) => {
    setOwnership(arg.target.value);
  };

  useEffect(() => {
    var _user = AppHelper.userCacheGet();
    setAuthOK(_user != null);
    setOUser(_user);	
    if (_user && _user.grade) {
      fetchGrades(_user);
	  fetchIAM(_user);
    }
  }, [open, isTea]);

  useEffect(() => {
    if (!model) {
      setGrade('P5'); 
      setTitle('');
      setTopic('');
      setQuestionData({
        text: '',
        files: [],
        grade: '',
        title: '',
        topic: '',
        transcribe: ''
      });
      setImageUrls([]);
      setOwnership(0);
      setSaQuestion(0);
      setQuestionDataType('text');
      setIsEdit(false);
    } else {
      setGrade(model.grade);
      setTitle(model.title);
      setTopic(model.topic);  
      setImageUrls([]);
      setOwnership(model.uploadType);
      setSaQuestion(model.saQuestion);
      setIsEdit(true);
  
      setQuestionData(prev => ({
        ...prev,
        title: model.title,
        grade: model.grade,
        text: model.topic
      }));
  
      if (model.images && model.images > 0) {
        fetchImages(model.questionId);
        setQuestionDataType("image");
      } else {
        setQuestionDataType("text");
      }
    }
  }, [model]); 

  useEffect(() => {
  }, []);

  const fetchAccessRight = async (oUser) => {
    var _resAccess = await AppHelper.apiPost("api/access", {
      token: oUser.token, profileId: oUser.profileId
    });
    var _accessAll = (_resAccess && _resAccess.status && _resAccess.data) ? _resAccess.data : [];
    let defaultAccess = 0;
    //to those account that have no given access (Self identify as tutor, not given access by tuition center)
    if (_resAccess.data.length == 0) {
      defaultAccess = 2;
    }
    var _gradeList=[
      {v:'P1', a:defaultAccess}, {v:'P2', a:defaultAccess}, {v:'P3', a:defaultAccess},
      {v:'P4', a:defaultAccess}, {v:'P5', a:defaultAccess}, {v:'P6', a:defaultAccess},
      {v:'S1', a:defaultAccess}, {v:'S2', a:defaultAccess}, {v:'S3', a:defaultAccess},
      {v:'S4', a:defaultAccess}, {v:'S4E', a:defaultAccess}, {v:'S5', a:defaultAccess},
    ];
      var access = [];
      access = _gradeList.map(g => ({ ...g }));//[..._gradeList];
      access.forEach(a=>{
        var _access = _accessAll.find(r=>r.grade == a.v);
        if(_access) a.a = _access.access;
        if (a.a == 2) {
          setManageAccess(prevAccess => [...prevAccess, a.v]);
        }
      });
      return;
  }

  const handleSubmit = async () => {
    setLoading(true);
    await handleQuestionSubmit();
    setLoading(false);
  };

  const handleQuestionSubmit = async () => {
    let editorContent = "";
    if (editorRef.current) {
      editorContent = editorRef.current.innerHTML;
    }
    
    if (AppHelper.isEmptyString(questionData.title)) {
      alert('Title is required');
      return;
    }
    const _topic = questionData.text;
    if (questionDataType == 'text' && AppHelper.isEmptyString(_topic)) {
      alert('Topic is required');
      return;
    }
	
	if(!model){
		if (questionDataType == 'image' && AppHelper.isEmptyString(questionData.transcribe)) {
		  alert('Upload image is required');
		  return;
		}
	}

    const images = [];
    var _url = 'api/question';
    if (model) _url = 'api/question/update';

    var _user = AppHelper.userCacheGet();

    if (questionData.files.length == 0) {

      var _res = await AppHelper.apiPost(_url, {
        token: _user.token, 
        title: questionData.title, topic: _topic, grade: grade, 
        b64: images, transcribe:questionData.transcribe, 
        questionId: model ? model.questionId : "",
        uploadType: ownership,
		saQuestion: saQuestion,
      });

      if (!_res || !_res.status) {
        alert('ERROR: Failed to submit question!');
        return;
      }
      else {
        setQuestionData({
          text: '',
          files: [],
		  title:'',

        });
        alert('Question submitted!');
        onClose(true);
      }
    }
    else {
      let totalSize = 0;

      // Calculate total size of all files
      for (let i = 0; i < questionData.files.length; i++) {
        totalSize += questionData.files[i].size;
      }

      // Check if total size exceeds 9MB (9 * 1024 * 1024 bytes)
      if (totalSize > 9 * 1024 * 1024) {
        alert('Total size of uploaded files cannot exceed 9MB.');
        return;
      }

      for (let i = 0; i < questionData.files.length; i++) {
        const reader = new FileReader();
        reader.readAsDataURL(questionData.files[i]);
        reader.onload = async () => {
          images.push(reader.result.split(',')[1]);
          if (images.length === questionData.files.length) {
            var _res = await AppHelper.apiPost(_url, {
              token: _user.token, 
              title: questionData.title, topic: '-', grade: grade, 
              b64: images, 
			  uploadType: ownership,
			  saQuestion: saQuestion,
              transcribe:questionData.transcribe, 
              questionId: model ? model.questionId : ""
            });

            if (!_res || !_res.status) {
              alert('ERROR: Failed to submit question!');
              return;
            }
            else {
              setQuestionData({
                text: '',
                files: [],
				title:'',
              });
              alert('Question submitted!');
			   onClose(true);
            }
          }
        };
      }
      // onClose(true);
    }
  };

  const handleClose = () => { onClose(false) };
  const editorRef = React.useRef(null);
  const onQuestionDataTypeChange = (event) => {
    setQuestionDataType(event.target.value);
  };
  
  const onSaQuestionChange = (event) => {
    setSaQuestion(event.target.value);
  };
  
  const onImgSelect = async(argEvent)=>{
    const files = argEvent.target.files;
    if(!files || files.length<1){
      setPreviewUrls([]);
      setQuestionData((prev) => ({ ...prev, files: [] }));
      return;
    }
    const fileArray = Array.from(files);
    const newPreviewUrls = fileArray.map((file) => URL.createObjectURL(file));
    setPreviewUrls((prev) => {
      prev.forEach((url) => URL.revokeObjectURL(url));
      return newPreviewUrls;
    });
  
    setIsTranscribing(true);
    const reader = new FileReader();
    reader.readAsDataURL(argEvent.target.files[0]);
    reader.onload = async () => {
      var _user = AppHelper.userCacheGet();
      const _b64 = reader.result.split(',')[1];
      var _res = await AppHelper.apiPost('api/question/transcribe', { token: _user.token, b64: _b64});
      setIsTranscribing(false);
      setQuestionData({ ...questionData, transcribe: _res.data, files:argEvent.target.files });
    };
  }
  
  const openImagePreview = (b64, alt='') => {
    setImagePreview({ open: true, src: b64, alt });
  };
  const closeImagePreview = () => setImagePreview({ open: false, src: '', alt: '' });

  return (
    <>
      <Dialog onClose={handleClose} open={open} fullWidth>
        <DialogTitle sx={{fontWeight: 'bold'}}>{model ? "EDIT QUESTION" : "ADD QUESTION"}</DialogTitle>
        <Box pl={2} pr={2} pb={2} alignItems="flex-start">

          <Grid>
            <Grid item xs={12} sm={6}>
              <Box m={.5} >
                <Grid item mb={0.5}>
                  <TextField
                    label="Question Title"
                    placeholder="e.g. My First Day in School"
                    helperText="Give your question a short, clear title."
                    rows={4}
                    variant="outlined"
                    fullWidth
                    value={questionData.title}
                    onChange={(e) => setQuestionData({ ...questionData, title: e.target.value })}
                    />
                </Grid>
                <Grid item mt={1.5}>
                  {gradeList && gradeList.length > 0 &&
                    <FormControl fullWidth>
                      <InputLabel id="demo-select-small-label">GRADE</InputLabel>
                      <Select labelId='lblGrade'
                        value={grade}
                        onChange={gradeSelect}
                        label="GRADE"
                        inputProps={{
                        }}
                        sx={{ "& fieldset": {} }}
                        fullWidth
                      >
                        {gradeList.map((item) => (
                          <MenuItem key={item.v} value={item.v}>
                            {item.n}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  }
                </Grid>
                <Grid item mt={1.5}>
				  {saQuestion == 0 && (
					<FormControl fullWidth>
					  <InputLabel id="demo-select-small-label">OWNERSHIP</InputLabel>
					  <Select
						labelId="lblGrade"
						value={ownership}
						onChange={ownershipSelect}
						label="OWNERSHIP"
						inputProps={{
						  // disableUnderline: true
						}}
						sx={{ "& fieldset": {} }}
						fullWidth
					  >
						<MenuItem value={0}>SELF</MenuItem>
						<MenuItem value={1}>TUITION CENTER</MenuItem>
					  </Select>
					</FormControl>
				  )}
				</Grid>
                <Grid item xs={12}>
                  <FormControl>
                    <RadioGroup row
                      value={questionDataType}
                      onChange={onQuestionDataTypeChange}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel value="text" control={<Radio />} label="TEXT" />
                      <FormControlLabel value="image" control={<Radio />} label="IMAGE" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                { questionDataType == 'text' &&
                <Grid item style={{ marginTop: '0' }}>
                  <TextField
                    label="Question Topic"
                    placeholder="e.g. School Life"
                    helperText="What is this essay mainly about?"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    value={questionData.text}
                    onChange={(e) => setQuestionData({ ...questionData, text: e.target.value })}
                    />
                </Grid>
                }
                { questionDataType == 'image' &&
                <Grid item style={{ marginTop: '16px' }}>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => onImgSelect(e)}
                  />
                </Grid>
                }
                
        { questionDataType == 'image' && 
          previewUrls && previewUrls.length > 0 && (
          <Grid container spacing={1} mt={1}>
            {previewUrls.map((url, index) => (
              <div style={{position: "relative", display: "inline-block"}}>
                  <Tooltip title="Click to view full image" arrow>
                <IconButton
                onClick={(e) => openImagePreview(url)}
                sx={{
                  position: 'absolute',
                  top: "50%", 
                  left: "50%", 
                  transform: "translate(-50%, -50%)", 
                  color: 'rgba(255, 255, 255, 0.8)', 
                  backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                  marginTop: '-1rem', 
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  },
                }}>
                  <OpenInFullIcon />
                </IconButton>
                </Tooltip>
                  <a href="#" onClick={(e) => openImagePreview(url)}>
                    <img
                      src={url}
                      alt={`Preview ${index + 1}`}
                      style={{ width: 120, height: 'auto', marginBottom: '8px' }}
                    />
                  </a>
                </div>
            ))}
          </Grid>
        )}
				
				{/* {imageUrls && imageUrls.length > 0 && 
				  imageUrls.map((imageUrl, index) => (
					<Grid item key={index} xs={6} sm={4} md={3}>
					  <img
						src={`data:image/jpeg;base64,${imageUrl}`}
						alt={`Image ${index + 1}`}
						style={{ maxWidth: '100%' }}
					  />
					</Grid>
				  ))
				} */}

				{ isSa &&
				<Grid item xs={12}>
				  <FormControl sx={{ marginTop: 2 }} component="fieldset" fullWidth>
					<FormLabel component="legend">System-wide Question</FormLabel> {/* Use FormLabel instead of InputLabel */}
					<RadioGroup
					  row
					  value={saQuestion}
					  onChange={onSaQuestionChange}
					  aria-labelledby="demo-row-radio-buttons-group-label"
					  name="row-radio-buttons-group"
					>
					  <FormControlLabel value="1" control={<Radio />} label="YES" />
					  <FormControlLabel value="0" control={<Radio />} label="NO" />
					</RadioGroup>
				  </FormControl>
				</Grid>
				}
				
              </Box>
            </Grid>
            <Grid container pt={.5}>
              <Grid item xs={6}>

              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <LoadingButton
                    className="app-btn-bg"
                    onClick={handleSubmit}
                    // loading={isSubmitting || isTranscribing}
                    variant="contained"
                    disabled={isTranscribing}
                    sx={{
                      "&.Mui-disabled": {
                        color: "lightgrey", 
                      }
                    }}
                  >
                  {isTranscribing ? "PROCESSING..." : "UPLOAD"}
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Dialog open={imagePreview.open} onClose={closeImagePreview} maxWidth="md" fullWidth>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', position: "relative" }}>
          <IconButton
          onClick={closeImagePreview}
          style={{
            width: "25px", 
            height: "25px",
            position: 'absolute',
            top: "2rem", 
            right: "1rem", 
            color: 'rgba(255, 255, 255, 0.8)', 
            backgroundColor: 'rgba(0, 0, 0, 0.6)', 
            margin: '5px', 
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
          }}>
            <CloseIcon />
          </IconButton>
          <img
          src={imagePreview.src}
          alt={imagePreview.alt || 'Preview'}
          style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Box>
      </Dialog>
      </Dialog>
    </>
  );
}
